import { Design as GrapeJsDesign } from 'views/PrintTemplate/components';
import { default as useGrapeJsTemplate } from 'views/PrintTemplate/useTemplate';

const IFrameGrapejsEditor = props => {
    const grapjeJsTemplate = useGrapeJsTemplate();

    return (
        <GrapeJsDesign template={grapjeJsTemplate} showNav={true} isIFrame={true} />
    )
}

export default IFrameGrapejsEditor;